<nav class="app-page-sidenav" aria-label="Page navigation">
  <ul class="app-page-sidenav__list">
    @for (data of sideData; track data; let i = $index) {
      <li class="app-page-sidenav__item"
        routerLinkActive="active" [routerLinkActiveOptions]="{exact: true}">
        <a class="app-page-sidenav__link" [routerLink]="data.route">
          <i class="fa fa-{{data.img}}" aria-hidden="true"></i>
          <span>{{data.name | translate}}</span>
        </a>
      </li>
    }
  </ul>
</nav>
